import { Box, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import * as FaIcons from "react-icons/fa";
import React, { useState, useContext } from "react";
import { useBackendStatusContext } from "../context/backendStatus/backendStatusContext";
import { SET_SAVED_TARGET_VERSION, SET_UPDATE_REQUESTED } from "../context/backendStatus/backendStatusActions";
import { updateBackend } from "../actions/backendVersionActions";
import { useTheme } from '@mui/material/styles';
import { useTranslation } from "../context/TranslationContext";
import ConfirmationDialog from "./ConfirmationModals/ConfirmationDialog";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { ScreenResolutionContext } from "../context/screenResolutionContext";
import { usePollingManager } from "../context/PollingManagerContext";
import { TestWorkflowAction } from "../constants/testWorkflowState";
import { useAppWorkflowContext } from "../context/AppWorkflowContext";

const UpdateButton = ({ forceShow = false, selectedVersion }) => {
	const backendStatus = useBackendStatusContext();
	const theme = useTheme(); 
	const { translate } = useTranslation();
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const { dispatchWorkflow } = useAppWorkflowContext();
	const { runningState } = usePollingManager();
	const isTestNotFailedAndNotReported = runningState?.isTestNotFailedAndNotReported ?? true;

	const { screenSizeCategory } = useContext(ScreenResolutionContext);
	const isMediumScreen = screenSizeCategory === 'md';
	const isSmallScreen = screenSizeCategory === 'xs' || screenSizeCategory === 'sm';

	const handleOpenDialog = () => {
		setIsDialogOpen(true);
	};

	const handleClose = () => {
		setIsDialogOpen(false);
	};

	const handleUpdate = async () => {
		setIsDialogOpen(false);
		//avoiding re-entrancy when the button is clicked multiple times or when the backend is already updating
		if (backendStatus.state.isUpdating) {
			return;
		}
		backendStatus.dispatch({ type: SET_UPDATE_REQUESTED });
		dispatchWorkflow({ type: TestWorkflowAction.ENTER_BACKEND_UPDATING });

		// Use targetVersion from state if selectedVersion is null
		const versionToUpdate = selectedVersion || backendStatus.state.targetVersion;
		backendStatus.dispatch({ type: SET_SAVED_TARGET_VERSION });
		await updateBackend(versionToUpdate);
	};
	return (
		(forceShow || backendStatus.state.isUpdatePossible) && (
			<Box mr={1} sx={{
				display: "flex",
				alignItems: "center",
				color: theme.palette.primary.main,
				flexWrap: "nowrap",
				gap: isSmallScreen ? "4px" : "8px",
			}}>
				<Typography sx={{ fontSize: isSmallScreen ? "12px" : isMediumScreen ? "14px" : "16px"}}>{translate("settings.updateAvailable")}</Typography>
				<LoadingButton
					variant="outlined"
					startIcon={<FaIcons.FaDownload style={{fontSize: isSmallScreen ? '12px' : "16px"}} />}
					onClick={handleOpenDialog}
					loading={backendStatus.state.isUpdateRequested}
					size={"small"}
					sx={{
						ml: 1, fontSize: isSmallScreen ? "10px" : isMediumScreen ? "11px" : "13px", whiteSpace: isSmallScreen ? "wrap" : "nowrap",
						display: "flex",
						alignItems: "center",
						pl: "12px", pr: "12px",
						minWidth: isSmallScreen ? "100px" : "auto",
						maxWidth: "100%",
					}}
				>
					{translate("settings.install")} {backendStatus.state.targetVersion}	
				</LoadingButton>
				<ConfirmationDialog
					title={isTestNotFailedAndNotReported ? translate("confirmUpdate.confirm") : translate("confirmUpdate.updateNotPossible")}
					subtitle={isTestNotFailedAndNotReported ? translate("confirmUpdate.areYouSureUpdate") : translate('header.waitUntilTestAnalysisComplete')}
					isOpen={isDialogOpen}
					confirmDisabled={!isTestNotFailedAndNotReported}
					icon={isTestNotFailedAndNotReported ? <QuestionMarkIcon style={{ fontSize: "74px" }} /> : <PriorityHighIcon style={{ fontSize: "74px" }} />}
					onClose={handleClose}
					onConfirm={handleUpdate}
				/>
			</Box>
		)
	);
};

export default UpdateButton;
